import { useMemorandumLogo } from "hooks/MemorandumLogo";
import { useSelector } from "react-redux";
import { selectState } from "../output.slice";
import { FormatDate, FormatDateShort } from "utils/dateUtils";
import "../../Input/styles/print.scss";
import { categoryDictionary } from "utils/translationDictionary";
import { FormatNumberWithUnitOrNull } from "utils/numberUtils";

const PrintOutput = () => {
  const memorandumLogo = useMemorandumLogo();
  const { listItems } = useSelector(selectState);

  return (
    <>
      <div className="logo">
        {memorandumLogo && <img src={memorandumLogo} alt="" />}
      </div>
      <h1 className="header-consumables-output">Potrošni materijal - IZLAZ</h1>
      <div className="output-date">{FormatDate(new Date().toISOString())}</div>
      <table className="consumables-output-ts table-header-consumables">
        <tbody>
          <tr>
            <th>otpr-rač</th>
            <th>Naziv</th>
            <th>dobavljač</th>
            <th>kategorija</th>
            <th>kol. izdatog</th>
            <th>dat izlaza</th>
            <th>za resurs</th>
          </tr>
        </tbody>
      </table>
      <table className="consumables-output-ts consumables-output-t table-body">
        <tbody>
          {listItems &&
            listItems.map((listItem, listItemIndex) =>
              <tr key={listItem.outputItemId}>
                <td>
                  <label>{listItem.inputBillOfLandingId}</label>
                </td>
                <td>
                  <label>{listItem.name}</label>
                </td>
                <td>
                  <label>{listItem.supplier}</label>
                </td>
                <td className="consumables-output-bordered">
                  <label>{categoryDictionary[listItem.category]}</label>
                </td>
                <td className="consumables-output-bordered">
                  {FormatNumberWithUnitOrNull(listItem.quantityAmount, listItem.unit.name)}
                </td>
                <td className="consumables-output-bordered">
                  {FormatDateShort(listItem.date)}
                </td>
                <td>
                  <label>{listItem.resourceOverride
                    ? listItem.resourceOverride.nameWithIdentifier : listItem.resource?.nameWithIdentifier}
                  </label>
                </td>
              </tr>
            )}
        </tbody>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>

        <tr className="footer">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </table>
    </>
  );
};

export default PrintOutput;
